import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import RollOver from '../../components/roll-over/index';
import {
    downloadRolloverTemplate,
    downloadSchoolRollDataRollover,
    hideHelpModal,
    rollOverIsFull,
    rollOverIsPartial,
    showHelpModal,
    showInitialPage,
    showSelectionPage,
    showUploadPage,
    rolloverUploadFailure,
    closeUploadErrorModal,
    rollOverVerifyContentRequest,
    clearRollOverVerifyData,
    openRollOverConfirmation,
    closeRollOverConfirmation,
    onRollOverConfirmationRequest,
    onViewRollOverSummary,
    onRollOverDownloadSignInCardRequest,
    onIncludeUnassignedStudentsSelection,
    onIncludeBulkTransferSelection
} from './actions';
import { showHideSignInCardModalRequest } from '../class-roll/actions';

const RollOverContainer = props => (
    <RollOver {...props} />
);

const mapStateToProps = state => ({
    helpModal: state.rollOver.helpModal,
    initialPage: state.rollOver.initialPage,
    isDownloadingSchoolRollData: state.rollOver.isDownloadingSchoolRollData,
    isDownloadingTemplate: state.rollOver.isDownloadingTemplate,
    isPartialRollover: state.rollOver.isPartialRollover,
    isFullRollover: state.rollOver.isFullRollover,
    selectionPage: state.rollOver.selectionPage,
    selectedProduct: state.product,
    uploadPage: state.rollOver.uploadPage,
    message: state.rollOver.message,
    showUploadModal: state.rollOver.showUploadModal,
    isVerifyingContent: state.rollOver.isVerifyingContent,
    isVerificationSuccessful: state.rollOver.isVerificationSuccessful,
    validationErrors: state.rollOver.validationErrors,
    showDataGrid: state.rollOver.showDataGrid,
    rolloverItems: state.rollOver.rolloverItems,
    showRollOverConfirmation: state.rollOver.showRollOverConfirmation,
    rolloverType: state.rollOver.rolloverType,
    isPerformingRollOver: state.rollOver.isPerformingRollOver,
    isRolloverDone: state.rollOver.isRolloverDone,
    rolloverSummary: state.rollOver.rolloverSummary,
    summaryPage: state.rollOver.summaryPage,
    isDownloadingRolloverSignInCards: state.rollOver.isDownloadingRolloverSignInCards,
    includeUnassignedStudents: state.rollOver.includeUnassignedStudents,
    includeBulkTransfer: state.rollOver.includeBulkTransfer,
    isServerError: state.rollOver.isServerError,
    fileSize: state.rollOver.fileSize,
    showHideSignInCardModal: state.classRoll.showHideSignInCardModal
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        downloadRolloverTemplate,
        downloadSchoolRollDataRollover,
        hideHelpModal,
        showHelpModal,
        rollOverIsFull,
        rollOverIsPartial,
        showInitialPage,
        showSelectionPage,
        showUploadPage,
        rolloverUploadFailure,
        closeUploadErrorModal,
        rollOverVerifyContentRequest,
        clearRollOverVerifyData,
        openRollOverConfirmation,
        closeRollOverConfirmation,
        onRollOverConfirmationRequest,
        onViewRollOverSummary,
        onRollOverDownloadSignInCardRequest,
        onIncludeUnassignedStudentsSelection,
        onIncludeBulkTransferSelection,
        showHideSignInCardModalRequest
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(RollOverContainer));



// WEBPACK FOOTER //
// ./app/containers/roll-over/index.js